import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LocationLandingPage from './LocationLandingPage';
import LandingPage from './LandingPage';
import StationDetail from './StationDetail';
import FeedbackPage from './FeedbackPage';
import PrivacyPage from './PrivacyPage';
import TermsPage from './TermsPage';
import SmartAppBanner from './components/SmartAppBanner';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <SmartAppBanner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LocationLandingPage />} />
            <Route path="/legacy" element={<LandingPage />} />
            <Route path="/station/:stationId" element={<StationDetail />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
